export default __webpack_public_path__ + "static/media/ri_filter-3-line.4f52a150.svg";